export default "__VITE_ASSET__4cMvEzdT__"